import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getProjectApprovalSummaryForStaffSubProject } from '../../../../redux/actions/projectApprovalSummaryForStaff'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import ProjectApprovalSummaryForStaffWidget from '../../../../widgets/projectApprovalSummaryForStaff/ProjectApprovalSummaryForStaffWidget'
import ProposeConsiderApproveProjectUploadSubProjectWidget from '../../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectUploadSubProjectWidget'

export default function ProjectApprovalSummaryForStaff() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setErrors] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectApprovalSummaryForStaffSubProject(proposalId)
      console.log('res => ', _schema)

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)

    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema.uploadDocuments && (
            <ProposeConsiderApproveProjectUploadSubProjectWidget
              showCommandButton={!schema?.disabled}
              schema={schema.uploadDocuments}
            />
          )}

          {schema.forms && (
            <>
              <ProjectApprovalSummaryForStaffWidget schema={schema.forms} />
              <br />
            </>
          )}
        </SidebarProposal>
      )}
    </>
  )
}
